import Head from 'next/head'
import Layout from 'components/layout'
import { Container, Button } from 'components/ui'
import { FC } from 'react'
import Link from 'next/link'
import { ROUTE_PRODUCT_INDEX } from 'routes/products'

const ProdutoNaoEncontrado: FC = () => {
  return (
    <Layout>
      <Head>
        <title>Produto não disponível | Fazendinha em Casa</title>
      </Head>
      <Container>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '4rem 2rem', textAlign: 'center' }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '1rem' }}>
            Produto não disponível
          </h1>
          <p style={{ color: '#666', marginBottom: '2rem', maxWidth: '420px', lineHeight: 1.6 }}>
            Este produto não está mais disponível para venda no momento.
            Que tal descobrir outros produtos fresquinhos da Fazendinha?
          </p>
          <Link href={ROUTE_PRODUCT_INDEX}>
            <a>
              <Button variant="primary">Ver outros produtos</Button>
            </a>
          </Link>
        </div>
      </Container>
    </Layout>
  )
}

export default ProdutoNaoEncontrado
